<div
  class="notification-container"
  animate.enter="enter-animation"
  animate.leave="leave-animation"
  fxLayout="column">
  @if (messageType !== NotificationType.MassCommunication) {
    <div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (!showDefaultIcon) {
            <div class="from-icon">
              <img
                [src]="fromIcon"
                (error)="iconLoad($event)" />
            </div>
          }
          <div class="from-name ml-2">{{ fromName }}</div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (distance) {
            <div
              class="distance-pill"
              fxLayout="row"
              fxLayoutAlign="space-between center">
              <div class="left-side">&nbsp;</div>
              <div
                class="distance-pill-value"
                fxLayout="row"
                fxLayoutAlign="start center">
                {{ distance }}
              </div>
              <div class="right-side">&nbsp;</div>
            </div>
          }
          <div
            class="close-button ml-4"
            (click)="hide()">
            <i class="icon icon-small_close-X"></i>
          </div>
        </div>
      </div>
      <div
        class="message mt-3"
        [innerHTML]="message | safeHtml"></div>
      @if (location) {
        <div
          fxLayout="row"
          class="mt-3">
          <div class="location-icon pr-1"><i class="icon icon-zoom-to_location"></i></div>
          <div class="location">{{ location }}</div>
        </div>
      }
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-2">
        <div fxLayout="row">
          <div class="date-sent-label pr-1">{{ 'MAP.POSTED' | translate }}</div>
          <div class="date-sent">{{ dateSentFormatted }}</div>
        </div>
        <div class="elapsed-time">
          {{ dateSentElapsedTime }}
        </div>
      </div>
    </div>
  }
  @if (messageType === NotificationType.MassCommunication) {
    <div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <div>
            <i class="icon icon-alert_solid escalated-icon"></i>
          </div>
          <div class="from-name ml-2">
            {{ 'NOTIFICATIONS.ESCALATED-RESPONSE' | translate }}
          </div>
        </div>
      </div>
      @if (escalatedMessage) {
        <div
          class="escalated-message mt-3"
          [innerHTML]="escalatedMessage | safeHtml"></div>
      }
      @if (recipientName) {
        <div class="escalated-address mt-2">
          {{ recipientName }}
        </div>
      }
      <div
        class="mt-2"
        fxLayout="row"
        fxLayoutGap="12px">
        <img
          class="bullhorn-image"
          src="assets/images/purple_bullhorn.svg" />
        <div>
          {{ message }}
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-2">
        <div fxLayout="row">
          <div class="date-sent-label pr-1">{{ 'MAP.POSTED' | translate }}</div>
          <div class="date-sent">{{ dateSentFormatted }}</div>
        </div>
        <div class="elapsed-time">
          {{ dateSentElapsedTime }}
        </div>
      </div>
    </div>
  }
</div>
